export type ParamVal = string | number | boolean;

export interface ParamType {
    [key: string]: ParamVal;
}

export const getResolvedUrl = (route: string, dependencies: ParamType) => {
    if (!route.includes("{") || !route.includes("}")) return route;

    let resolvedRoute = route;
    const replaceableKeys = Object.keys(dependencies);
    for (const key of replaceableKeys) {
        const str = `{${key}}`;
        resolvedRoute = resolvedRoute.replace(str, `${dependencies[key]}`);
    }
    return resolvedRoute;
};
